import { render, staticRenderFns } from "./OrdenarAbiertas.vue?vue&type=template&id=650742e6&scoped=true&"
import script from "./OrdenarAbiertas.vue?vue&type=script&lang=js&"
export * from "./OrdenarAbiertas.vue?vue&type=script&lang=js&"
import style0 from "./OrdenarAbiertas.vue?vue&type=style&index=0&id=650742e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650742e6",
  null
  
)

export default component.exports